import { EMPTY_TEXT, formatMonthRange } from '../utils/resumeTransforms';
import { setXinZi } from '../../utils';

export const getDisplayValue = (field, data = {}) => {
  if (!field) return EMPTY_TEXT;

  if (field.type === 'salary') {
    const salary = setXinZi(data);
    return salary ? `${salary}${field.unit || ''}` : EMPTY_TEXT;
  }

  if (field.type === 'monthRange') {
    return formatMonthRange(data[field.from], data[field.to]);
  }

  if (Array.isArray(field.props)) {
    console.log('field.props', field.props);
    return field.props.map((prop) => data[prop]).filter(Boolean).join(' / ') || EMPTY_TEXT;
  }

  const value = data[field.props];
  return   value !== undefined && value !== null && value !== '' ? value : EMPTY_TEXT;
};
